"use client";
import { useTheme } from "next-themes";
import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import useWindowSize from "../../hooks/useWindowSize";
export default function PSLogo({ overrideLight }) {
  const { theme } = useTheme();
  const [color, setColor] = useState("#112756");
  const size = useWindowSize();
  const width = size?.width ?? 0;
  useEffect(() => {
    setColor(
      theme === "dark" ? "#FFFFFF" : overrideLight ? overrideLight : "#112756"
    );
  }, [overrideLight, theme]);
  return (
    <motion.div
      // initial={{ scale: 0, opacity: 0.3 }}
      // animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.3 }}
      whileTap={{ scale: 0.9 }}
      className="animate-pulse"
      transition={{
        type: "tween",
        stiffness: 260,
        damping: 20,
        duration: 2,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width < 700 ? "100px" : "200px"}
        height={width < 700 ? "84px" : "168px"}
        viewBox="0 0 330 278.348"
      >
        <defs>
          <filter id="dropshadow" height="130%">
            <feGaussianBlur in="SourceAlpha" stdDeviation="3" />
            <feOffset dx="2" dy="2" result="offsetblur" />
            <feComponentTransfer>
              <feFuncA type="linear" slope="0.5" />
            </feComponentTransfer>
            <feMerge>
              <feMergeNode />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>
        <g filter="url(#dropshadow)">
          <g
            id="Group_304"
            data-name="Group 304"
            transform="translate(0 0.001)"
          >
            <g
              id="Group_303"
              data-name="Group 303"
              transform="translate(0 -0.001)"
              clipPath="url(#clipPath)"
            >
              <path
                id="Path_2898"
                data-name="Path 2898"
                d="M33.288,786.393a17.518,17.518,0,0,1,7.56,6.72,21.289,21.289,0,0,1,0,20.58,17.2,17.2,0,0,1-7.56,6.719,26.749,26.749,0,0,1-11.574,2.329h-10.1v14.737H0V784.026H21.714a26.4,26.4,0,0,1,11.574,2.367m-4.264,23.862a8.637,8.637,0,0,0,2.723-6.834,8.733,8.733,0,0,0-2.723-6.909q-2.725-2.405-7.955-2.406h-9.46v18.555h9.46q5.23,0,7.955-2.406"
                transform="translate(0 -584.009)"
                fill={color}
              />
              <path
                id="Path_2899"
                data-name="Path 2899"
                d="M186.061,835.817a25.391,25.391,0,0,1-8.626-4.319l3.811-9.006a25.274,25.274,0,0,0,7.414,3.913,26.253,26.253,0,0,0,8.592,1.477q4.781,0,7.067-1.514a4.622,4.622,0,0,0,2.286-4.023,3.949,3.949,0,0,0-1.351-3.063,10.066,10.066,0,0,0-3.464-1.957q-2.115-.737-5.716-1.624A75.126,75.126,0,0,1,187,812.894a14.756,14.756,0,0,1-6.062-4.5,12.679,12.679,0,0,1-2.529-8.269,15.068,15.068,0,0,1,2.287-8.158,15.594,15.594,0,0,1,6.894-5.794,26.611,26.611,0,0,1,11.259-2.142,35.155,35.155,0,0,1,9.077,1.182,25.975,25.975,0,0,1,7.76,3.4l-3.464,9.081a25.816,25.816,0,0,0-13.442-4.061q-4.712,0-6.963,1.624a5.039,5.039,0,0,0-2.252,4.282,4.188,4.188,0,0,0,2.6,3.95,38.881,38.881,0,0,0,7.934,2.547,75.816,75.816,0,0,1,9.076,2.805,15.054,15.054,0,0,1,6.063,4.43,12.385,12.385,0,0,1,2.529,8.194,14.777,14.777,0,0,1-2.321,8.085,15.8,15.8,0,0,1-6.964,5.794,26.854,26.854,0,0,1-11.294,2.142,37.375,37.375,0,0,1-11.121-1.662"
                transform="translate(-132.169 -584.01)"
                fill={color}
              />
              <path
                id="Path_2900"
                data-name="Path 2900"
                d="M385.141,876.121a18.911,18.911,0,0,1-6.422-3.215l2.837-6.705a18.771,18.771,0,0,0,5.52,2.912,19.529,19.529,0,0,0,6.4,1.1,9.689,9.689,0,0,0,5.261-1.127,3.441,3.441,0,0,0,1.7-3,2.941,2.941,0,0,0-1.006-2.28,7.476,7.476,0,0,0-2.579-1.457q-1.574-.549-4.256-1.21a55.875,55.875,0,0,1-6.758-2.088,11,11,0,0,1-4.514-3.353,9.446,9.446,0,0,1-1.882-6.156,11.216,11.216,0,0,1,1.7-6.073,11.617,11.617,0,0,1,5.133-4.315,19.828,19.828,0,0,1,8.382-1.593,26.116,26.116,0,0,1,6.758.879,19.292,19.292,0,0,1,5.777,2.528l-2.579,6.761a19.219,19.219,0,0,0-10.007-3.023,8.93,8.93,0,0,0-5.184,1.209,3.752,3.752,0,0,0-1.676,3.188,3.117,3.117,0,0,0,1.934,2.94,28.987,28.987,0,0,0,5.906,1.9,56.227,56.227,0,0,1,6.758,2.09,11.2,11.2,0,0,1,4.514,3.3,9.218,9.218,0,0,1,1.883,6.1,10.994,10.994,0,0,1-1.728,6.019,11.764,11.764,0,0,1-5.184,4.315,20,20,0,0,1-8.408,1.593,27.827,27.827,0,0,1-8.279-1.236"
                transform="translate(-282.102 -623.89)"
                fill={color}
              />
              <path
                id="Path_2901"
                data-name="Path 2901"
                d="M539.04,869.968v7.391H510.123V837.565H539.04v7.39H518.713v8.64h17.339v7.164H518.713v9.209Z"
                transform="translate(-379.983 -623.891)"
                fill={color}
              />
              <rect
                id="Rectangle_293"
                data-name="Rectangle 293"
                width="8.643"
                height="39.793"
                transform="translate(237.481 213.675)"
                fill={color}
              />
              <path
                id="Path_2902"
                data-name="Path 2902"
                d="M985.109,874.8a18.449,18.449,0,0,1-7.017-7.09,21.859,21.859,0,0,1,0-20.5,18.445,18.445,0,0,1,7.017-7.091,21.148,21.148,0,0,1,18.518-.8,17.148,17.148,0,0,1,6.371,5.056l-5.365,5.278a11.262,11.262,0,0,0-9.078-4.508,11.469,11.469,0,0,0-5.983,1.566,10.806,10.806,0,0,0-4.1,4.37,14.556,14.556,0,0,0,0,12.752,10.81,10.81,0,0,0,4.1,4.369,11.469,11.469,0,0,0,5.983,1.566,11.211,11.211,0,0,0,9.078-4.562l5.365,5.277a16.87,16.87,0,0,1-6.4,5.111,20.117,20.117,0,0,1-8.512,1.758,19.711,19.711,0,0,1-9.98-2.555"
                transform="translate(-726.666 -623.89)"
                fill={color}
              />
              <path
                id="Path_2903"
                data-name="Path 2903"
                d="M1150.308,869.968v7.391h-28.917V837.565h28.917v7.39H1129.98v8.64h17.339v7.164H1129.98v9.209Z"
                transform="translate(-835.308 -623.891)"
                fill={color}
              />
              <path
                id="Path_2904"
                data-name="Path 2904"
                d="M660.99,877.357l-7.2-11.085h-7.949v11.085H637.2V837.565h16.166a19.676,19.676,0,0,1,8.617,1.762,13.055,13.055,0,0,1,5.628,5A14.468,14.468,0,0,1,669.58,852a14.168,14.168,0,0,1-2,7.646,12.883,12.883,0,0,1-5.683,4.917l8.377,12.79Zm-2.187-30.5a8.692,8.692,0,0,0-5.922-1.791h-7.042v13.871h7.042a8.6,8.6,0,0,0,5.922-1.818,7.506,7.506,0,0,0,0-10.262"
                transform="translate(-474.638 -623.89)"
                fill={color}
              />
              <path
                id="Path_2905"
                data-name="Path 2905"
                d="M800.972,837.565l-16.166,39.793H776.27l-16.112-39.793h9.336l11.364,28.423,11.523-28.423Z"
                transform="translate(-566.231 -623.891)"
                fill={color}
              />
              <path
                id="Path_2906"
                data-name="Path 2906"
                d="M344.135,477.063c-6.5,0-11.792-5.637-11.792-12.565V395.877a3.091,3.091,0,1,1,6.17,0V464.5a5.822,5.822,0,0,0,5.623,5.991,5.478,5.478,0,0,0,3.736-1.51L379.4,435.386l1.869.761a63.153,63.153,0,0,0,62.134-8.281,70.348,70.348,0,0,0,24.009-33.14,3.032,3.032,0,0,1,3.969-1.929,3.354,3.354,0,0,1,1.81,4.229,76.867,76.867,0,0,1-26.229,36.209,68.884,68.884,0,0,1-66.008,9.789L352.11,473.76l-.062.059a11.435,11.435,0,0,1-7.913,3.245"
                transform="translate(-247.558 -292.434)"
                fill={color}
              />
              <path
                id="Path_2907"
                data-name="Path 2907"
                d="M474.6,84.472q-.077,0-.154,0a3.215,3.215,0,0,1-2.93-3.444c.054-1.175.082-2.369.082-3.548a74.676,74.676,0,0,0-4.379-25.345A70.3,70.3,0,0,0,443.187,19.36,63.357,63.357,0,0,0,405.055,6.573h-55.7c-5.977,0-10.841,5.182-10.841,11.551V81.185a3.091,3.091,0,1,1-6.169,0V18.124C332.342,8.13,339.973,0,349.352,0h55.7a69.24,69.24,0,0,1,41.672,13.977,76.817,76.817,0,0,1,26.253,35.8,81.617,81.617,0,0,1,4.787,27.7c0,1.287-.03,2.589-.089,3.87a3.179,3.179,0,0,1-3.079,3.126"
                transform="translate(-247.557 0.001)"
                fill={color}
              />
              <path
                id="Path_2908"
                data-name="Path 2908"
                d="M448.774,146.265A9.015,9.015,0,0,1,441,154.444a8.487,8.487,0,0,1-7.927-3.793,1.881,1.881,0,0,0-1.561-.823H412.154l-10.078,16.627a4.238,4.238,0,0,1-4.077,2.09,4.379,4.379,0,0,1-3.595-2.924l-9.363-25.756-17.6,47.273a4.05,4.05,0,0,1-4.021,2.594,3.809,3.809,0,0,1-.478-.028,4.136,4.136,0,0,1-3.8-3.545l-12.532-84.365L334.738,164.87a4.434,4.434,0,0,1-3.885,3.69,4.324,4.324,0,0,1-4.4-2.956l-9.682-27.1-4.062,8.716a4.306,4.306,0,0,1-3.866,2.559l-18.29.038a1.843,1.843,0,0,0-1.529.811,8.53,8.53,0,0,1-7.068,3.864c-4.985,0-9-4.471-8.687-9.858a9.038,9.038,0,0,1,8.26-8.679A8.514,8.514,0,0,1,289,139.77a1.878,1.878,0,0,0,1.561.818l15.586-.034,7.273-15.6A4.307,4.307,0,0,1,317.5,122.4a4.358,4.358,0,0,1,3.832,2.968l7.864,22.014L342.87,74.762a4.284,4.284,0,0,1,8.519.184l13.839,93.129,15.838-42.552a4.337,4.337,0,0,1,4.02-2.912h.019a4.351,4.351,0,0,1,4.021,2.948l10.285,28.292,6.75-11.135A4.271,4.271,0,0,1,409.8,140.6h21.74a1.838,1.838,0,0,0,1.527-.807,8.535,8.535,0,0,1,7.06-3.854c5.132,0,9.226,4.736,8.649,10.323"
                transform="translate(-203.538 -52.903)"
                fill={color}
              />
              <path
                id="Path_2909"
                data-name="Path 2909"
                d="M9.844,1042.714v12.2H8.5l-6.868-9.1v9.1H0v-12.2H1.341l6.868,9.1v-9.1Z"
                transform="translate(0 -776.703)"
                fill={color}
              />
              <path
                id="Path_2910"
                data-name="Path 2910"
                d="M52.938,1053.656a5.733,5.733,0,0,1-1.276-4.008v-6.935H53.3v6.865q0,3.921,3.221,3.921a3,3,0,0,0,2.4-.967,4.438,4.438,0,0,0,.834-2.954v-6.865h1.587v6.935a5.73,5.73,0,0,1-1.276,4.018,5.268,5.268,0,0,1-7.13-.01"
                transform="translate(-38.482 -776.703)"
                fill={color}
              />
              <path
                id="Path_2911"
                data-name="Path 2911"
                d="M111.059,1053.395v1.515h-8.307v-12.2h8.078v1.517h-6.443v3.745h5.74v1.481h-5.74v3.938Z"
                transform="translate(-76.538 -776.702)"
                fill={color}
              />
              <path
                id="Path_2912"
                data-name="Path 2912"
                d="M143.482,1054.217a5.067,5.067,0,0,1-1.889-1.107l.605-1.36a4.915,4.915,0,0,0,1.676,1.021,5.831,5.831,0,0,0,2.1.392,3.605,3.605,0,0,0,2.126-.515,1.612,1.612,0,0,0,.7-1.368,1.393,1.393,0,0,0-.384-1.019,2.542,2.542,0,0,0-.948-.6,16.46,16.46,0,0,0-1.594-.47,15.5,15.5,0,0,1-2.085-.663,3.435,3.435,0,0,1-1.357-1.019,2.838,2.838,0,0,1-.564-1.855,3.294,3.294,0,0,1,.482-1.761,3.365,3.365,0,0,1,1.464-1.255,5.633,5.633,0,0,1,2.436-.47,7.312,7.312,0,0,1,1.995.278,5.162,5.162,0,0,1,1.684.8l-.539,1.395a5.806,5.806,0,0,0-1.537-.741,5.393,5.393,0,0,0-1.6-.251,3.364,3.364,0,0,0-2.085.539,1.686,1.686,0,0,0-.695,1.393,1.378,1.378,0,0,0,.392,1.021,2.667,2.667,0,0,0,.973.609,14.265,14.265,0,0,0,1.578.462,15.292,15.292,0,0,1,2.077.662,3.518,3.518,0,0,1,1.349,1.011,2.776,2.776,0,0,1,.564,1.83,3.261,3.261,0,0,1-.491,1.751,3.324,3.324,0,0,1-1.488,1.254,5.812,5.812,0,0,1-2.453.462,7.431,7.431,0,0,1-2.494-.426"
                transform="translate(-105.471 -776.295)"
                fill={color}
              />
              <path
                id="Path_2913"
                data-name="Path 2913"
                d="M182.312,1044.229h-3.924v-1.516h9.468v1.516H183.93v10.682h-1.619Z"
                transform="translate(-132.878 -776.702)"
                fill={color}
              />
              <path
                id="Path_2914"
                data-name="Path 2914"
                d="M230.141,1054.91l-2.469-3.746c-.305.023-.545.034-.72.034h-2.829v3.712h-1.635v-12.2h4.464a5.087,5.087,0,0,1,3.5,1.133,3.957,3.957,0,0,1,1.276,3.119,4.28,4.28,0,0,1-.655,2.405,3.725,3.725,0,0,1-1.864,1.445l2.715,4.095Zm-.866-5.907a2.94,2.94,0,0,0,0-4.068,3.535,3.535,0,0,0-2.372-.705h-2.78v5.489h2.78a3.5,3.5,0,0,0,2.372-.716"
                transform="translate(-165.728 -776.702)"
                fill={color}
              />
              <path
                id="Path_2915"
                data-name="Path 2915"
                d="M271.32,1051.861h-6.083l-1.259,3.049h-1.684l5.184-12.2H269.1l5.2,12.2h-1.717Zm-.572-1.395-2.469-5.977-2.469,5.977Z"
                transform="translate(-195.378 -776.702)"
                fill={color}
              />
              <path
                id="Path_2916"
                data-name="Path 2916"
                d="M343.863,1054.91l-.017-8.887-4.137,7.4h-.752l-4.138-7.352v8.834H333.25v-12.2h1.341l4.775,8.573,4.709-8.573h1.341l.017,12.2Z"
                transform="translate(-248.233 -776.702)"
                fill={color}
              />
              <rect
                id="Rectangle_294"
                data-name="Rectangle 294"
                width="1.635"
                height="12.197"
                transform="translate(100.634 266.011)"
                fill={color}
              />
              <path
                id="Path_2917"
                data-name="Path 2917"
                d="M412.121,1054.217a5.07,5.07,0,0,1-1.889-1.107l.605-1.36a4.919,4.919,0,0,0,1.676,1.021,5.832,5.832,0,0,0,2.1.392,3.607,3.607,0,0,0,2.126-.515,1.612,1.612,0,0,0,.7-1.368,1.393,1.393,0,0,0-.384-1.019,2.541,2.541,0,0,0-.948-.6,16.434,16.434,0,0,0-1.594-.47,15.476,15.476,0,0,1-2.085-.663,3.435,3.435,0,0,1-1.357-1.019,2.837,2.837,0,0,1-.564-1.855,3.3,3.3,0,0,1,.482-1.761,3.368,3.368,0,0,1,1.464-1.255,5.631,5.631,0,0,1,2.436-.47,7.314,7.314,0,0,1,2,.278,5.166,5.166,0,0,1,1.685.8l-.539,1.395a5.817,5.817,0,0,0-1.538-.741,5.393,5.393,0,0,0-1.6-.251,3.365,3.365,0,0,0-2.085.539,1.687,1.687,0,0,0-.694,1.393,1.377,1.377,0,0,0,.392,1.021,2.665,2.665,0,0,0,.973.609,14.254,14.254,0,0,0,1.578.462,15.3,15.3,0,0,1,2.078.662,3.522,3.522,0,0,1,1.349,1.011,2.778,2.778,0,0,1,.564,1.83,3.259,3.259,0,0,1-.491,1.751,3.325,3.325,0,0,1-1.488,1.254,5.811,5.811,0,0,1-2.453.462,7.429,7.429,0,0,1-2.494-.426"
                transform="translate(-305.576 -776.295)"
                fill={color}
              />
              <rect
                id="Rectangle_295"
                data-name="Rectangle 295"
                width="1.635"
                height="12.197"
                transform="translate(115.858 266.011)"
                fill={color}
              />
              <path
                id="Path_2918"
                data-name="Path 2918"
                d="M473.334,1044.725a5.784,5.784,0,0,1-2.183-2.239,6.8,6.8,0,0,1,0-6.377,5.8,5.8,0,0,1,2.183-2.238,6.391,6.391,0,0,1,6.23,0,5.742,5.742,0,0,1,2.175,2.23,6.9,6.9,0,0,1,0,6.394,5.749,5.749,0,0,1-2.175,2.23,6.391,6.391,0,0,1-6.23,0m5.388-1.351a4.341,4.341,0,0,0,1.586-1.682,5.234,5.234,0,0,0,0-4.79,4.344,4.344,0,0,0-1.586-1.683,4.285,4.285,0,0,0-2.265-.609,4.369,4.369,0,0,0-2.281.609,4.3,4.3,0,0,0-1.6,1.683,5.234,5.234,0,0,0,0,4.79,4.3,4.3,0,0,0,1.6,1.682,4.362,4.362,0,0,0,2.281.611,4.278,4.278,0,0,0,2.265-.611m-1.268-13.434h2l-2.747,2.265h-1.472Z"
                transform="translate(-350.363 -767.188)"
                fill={color}
              />
              <path
                id="Path_2919"
                data-name="Path 2919"
                d="M537.7,1042.714v12.2h-1.341l-6.868-9.1v9.1h-1.635v-12.2H529.2l6.868,9.1v-9.1Z"
                transform="translate(-393.191 -776.703)"
                fill={color}
              />
              <path
                id="Path_2920"
                data-name="Path 2920"
                d="M605.454,1053.395v1.515h-8.308v-12.2h8.079v1.517h-6.443v3.745h5.74v1.481h-5.74v3.938Z"
                transform="translate(-444.805 -776.702)"
                fill={color}
              />
              <path
                id="Path_2921"
                data-name="Path 2921"
                d="M637.877,1054.217a5.061,5.061,0,0,1-1.888-1.107l.6-1.36a4.916,4.916,0,0,0,1.677,1.021,5.829,5.829,0,0,0,2.1.392,3.608,3.608,0,0,0,2.126-.515,1.612,1.612,0,0,0,.7-1.368,1.4,1.4,0,0,0-.384-1.019,2.55,2.55,0,0,0-.949-.6,16.434,16.434,0,0,0-1.594-.47,15.454,15.454,0,0,1-2.085-.663,3.431,3.431,0,0,1-1.357-1.019,2.837,2.837,0,0,1-.564-1.855,3.3,3.3,0,0,1,.482-1.761,3.365,3.365,0,0,1,1.464-1.255,5.634,5.634,0,0,1,2.437-.47,7.313,7.313,0,0,1,1.995.278,5.166,5.166,0,0,1,1.685.8l-.54,1.395a5.793,5.793,0,0,0-1.537-.741,5.394,5.394,0,0,0-1.6-.251,3.362,3.362,0,0,0-2.085.539,1.685,1.685,0,0,0-.7,1.393,1.377,1.377,0,0,0,.393,1.021,2.667,2.667,0,0,0,.973.609,14.281,14.281,0,0,0,1.579.462,15.314,15.314,0,0,1,2.077.662,3.518,3.518,0,0,1,1.349,1.011,2.778,2.778,0,0,1,.564,1.83,3.264,3.264,0,0,1-.491,1.751,3.322,3.322,0,0,1-1.488,1.254,5.81,5.81,0,0,1-2.453.462,7.436,7.436,0,0,1-2.494-.426"
                transform="translate(-473.739 -776.295)"
                fill={color}
              />
              <path
                id="Path_2922"
                data-name="Path 2922"
                d="M694.926,1054.217a5.063,5.063,0,0,1-1.889-1.107l.605-1.36a4.912,4.912,0,0,0,1.676,1.021,5.831,5.831,0,0,0,2.1.392,3.6,3.6,0,0,0,2.126-.515,1.613,1.613,0,0,0,.7-1.368,1.393,1.393,0,0,0-.385-1.019,2.543,2.543,0,0,0-.948-.6,16.468,16.468,0,0,0-1.6-.47,15.546,15.546,0,0,1-2.085-.663,3.442,3.442,0,0,1-1.357-1.019,2.84,2.84,0,0,1-.563-1.855,3.292,3.292,0,0,1,.482-1.761,3.361,3.361,0,0,1,1.463-1.255,5.635,5.635,0,0,1,2.437-.47,7.314,7.314,0,0,1,2,.278,5.158,5.158,0,0,1,1.684.8l-.54,1.395a5.8,5.8,0,0,0-1.537-.741,5.393,5.393,0,0,0-1.6-.251,3.363,3.363,0,0,0-2.085.539,1.687,1.687,0,0,0-.694,1.393,1.38,1.38,0,0,0,.392,1.021,2.667,2.667,0,0,0,.974.609,14.236,14.236,0,0,0,1.578.462,15.282,15.282,0,0,1,2.077.662,3.524,3.524,0,0,1,1.349,1.011,2.775,2.775,0,0,1,.564,1.83,3.259,3.259,0,0,1-.491,1.751,3.324,3.324,0,0,1-1.487,1.254,5.816,5.816,0,0,1-2.454.462,7.43,7.43,0,0,1-2.493-.426"
                transform="translate(-516.234 -776.295)"
                fill={color}
              />
              <path
                id="Path_2923"
                data-name="Path 2923"
                d="M737.834,1053.656a5.734,5.734,0,0,1-1.275-4.008v-6.935h1.635v6.865q0,3.921,3.221,3.921a3,3,0,0,0,2.4-.967,4.436,4.436,0,0,0,.833-2.954v-6.865h1.586v6.935a5.726,5.726,0,0,1-1.276,4.018,5.267,5.267,0,0,1-7.129-.01"
                transform="translate(-548.653 -776.703)"
                fill={color}
              />
              <path
                id="Path_2924"
                data-name="Path 2924"
                d="M812.854,1043.847a4.453,4.453,0,0,1,0,6.239,5.09,5.09,0,0,1-3.5,1.132h-2.829v3.693H804.89v-12.2h4.464a5.086,5.086,0,0,1,3.5,1.133M811.676,1049a2.929,2.929,0,0,0,0-4.061,3.533,3.533,0,0,0-2.371-.705h-2.78v5.471h2.78a3.533,3.533,0,0,0,2.371-.705"
                transform="translate(-599.551 -776.703)"
                fill={color}
              />
              <path
                id="Path_2925"
                data-name="Path 2925"
                d="M858.181,1054.91l-2.47-3.746c-.306.023-.545.034-.72.034h-2.829v3.712h-1.634v-12.2h4.463a5.087,5.087,0,0,1,3.5,1.133,3.959,3.959,0,0,1,1.275,3.119,4.282,4.282,0,0,1-.654,2.405,3.721,3.721,0,0,1-1.864,1.445l2.715,4.095Zm-.867-5.907a2.937,2.937,0,0,0,0-4.068,3.533,3.533,0,0,0-2.371-.705h-2.78v5.489h2.78a3.5,3.5,0,0,0,2.371-.716"
                transform="translate(-633.547 -776.702)"
                fill={color}
              />
              <path
                id="Path_2926"
                data-name="Path 2926"
                d="M896.45,1053.832a5.783,5.783,0,0,1-2.183-2.239,6.807,6.807,0,0,1,0-6.377,5.793,5.793,0,0,1,2.183-2.238,6.392,6.392,0,0,1,6.23,0,5.746,5.746,0,0,1,2.175,2.23,6.9,6.9,0,0,1,0,6.395,5.756,5.756,0,0,1-2.175,2.229,6.392,6.392,0,0,1-6.23,0m5.389-1.351a4.327,4.327,0,0,0,1.586-1.682,5.226,5.226,0,0,0,0-4.79,4.392,4.392,0,0,0-7.735,0,5.242,5.242,0,0,0,0,4.79,4.457,4.457,0,0,0,6.149,1.682"
                transform="translate(-665.536 -776.295)"
                fill={color}
              />
              <path
                id="Path_2927"
                data-name="Path 2927"
                d="M947.781,1044.229h-3.925v-1.516h9.469v1.516H949.4v10.682h-1.619Z"
                transform="translate(-703.065 -776.702)"
                fill={color}
              />
              <path
                id="Path_2928"
                data-name="Path 2928"
                d="M996.264,1053.395v1.515h-8.307v-12.2h8.078v1.517h-6.443v3.745h5.74v1.481h-5.74v3.938Z"
                transform="translate(-735.915 -776.702)"
                fill={color}
              />
              <path
                id="Path_2929"
                data-name="Path 2929"
                d="M1030.01,1053.832a5.751,5.751,0,0,1-2.166-2.23,6.9,6.9,0,0,1,0-6.394,5.732,5.732,0,0,1,2.175-2.23,6.041,6.041,0,0,1,3.106-.811,6.138,6.138,0,0,1,2.453.479,5.011,5.011,0,0,1,1.9,1.42l-1.062,1.1a4.144,4.144,0,0,0-3.221-1.446,4.443,4.443,0,0,0-2.307.609,4.3,4.3,0,0,0-1.611,1.683,5.242,5.242,0,0,0,0,4.79,4.292,4.292,0,0,0,1.611,1.682,4.435,4.435,0,0,0,2.307.611,4.152,4.152,0,0,0,3.221-1.464l1.063,1.1a5.09,5.09,0,0,1-1.9,1.429,6.084,6.084,0,0,1-2.461.488,6.006,6.006,0,0,1-3.1-.811"
                transform="translate(-765.041 -776.295)"
                fill={color}
              />
              <path
                id="Path_2930"
                data-name="Path 2930"
                d="M1075.391,1053.832a5.767,5.767,0,0,1-2.167-2.23,6.9,6.9,0,0,1,0-6.394,5.753,5.753,0,0,1,2.175-2.23,6.047,6.047,0,0,1,3.107-.811,6.137,6.137,0,0,1,2.452.479,5.011,5.011,0,0,1,1.9,1.42l-1.062,1.1a4.147,4.147,0,0,0-3.222-1.446,4.444,4.444,0,0,0-2.306.609,4.282,4.282,0,0,0-1.611,1.683,5.234,5.234,0,0,0,0,4.79,4.279,4.279,0,0,0,1.611,1.682,4.436,4.436,0,0,0,2.306.611,4.155,4.155,0,0,0,3.222-1.464l1.062,1.1a5.09,5.09,0,0,1-1.9,1.429,6.084,6.084,0,0,1-2.461.488,6,6,0,0,1-3.1-.811"
                transform="translate(-798.844 -776.295)"
                fill={color}
              />
              <rect
                id="Rectangle_296"
                data-name="Rectangle 296"
                width="1.635"
                height="12.197"
                transform="translate(286.35 266.011)"
                fill={color}
              />
              <path
                id="Path_2931"
                data-name="Path 2931"
                d="M1141.631,1044.725a5.783,5.783,0,0,1-2.183-2.239,6.807,6.807,0,0,1,0-6.377,5.793,5.793,0,0,1,2.183-2.238,6.392,6.392,0,0,1,6.23,0,5.746,5.746,0,0,1,2.175,2.23,6.9,6.9,0,0,1,0,6.394,5.752,5.752,0,0,1-2.175,2.23,6.392,6.392,0,0,1-6.23,0m5.388-1.351a4.339,4.339,0,0,0,1.588-1.682,5.242,5.242,0,0,0,0-4.79,4.342,4.342,0,0,0-1.588-1.683,4.282,4.282,0,0,0-2.264-.609,4.367,4.367,0,0,0-2.281.609,4.3,4.3,0,0,0-1.6,1.683,5.234,5.234,0,0,0,0,4.79,4.3,4.3,0,0,0,1.6,1.682,4.359,4.359,0,0,0,2.281.611,4.275,4.275,0,0,0,2.264-.611m-1.267-13.434h2l-2.747,2.265h-1.472Z"
                transform="translate(-848.168 -767.188)"
                fill={color}
              />
              <path
                id="Path_2932"
                data-name="Path 2932"
                d="M1206,1042.714v12.2h-1.341l-6.869-9.1v9.1h-1.635v-12.2h1.342l6.868,9.1v-9.1Z"
                transform="translate(-890.996 -776.703)"
                fill={color}
              />
              <path
                id="Path_2933"
                data-name="Path 2933"
                d="M1257.335,804.622a5.644,5.644,0,1,1,5.284-5.721,5.459,5.459,0,0,1-5.284,5.721m-.017-.872a4.78,4.78,0,1,0-4.474-4.793,4.63,4.63,0,0,0,4.474,4.793"
                transform="translate(-932.62 -590.947)"
                fill={color}
              />
              <path
                id="Path_2934"
                data-name="Path 2934"
                d="M1267.224,810.438h-.813v-5.2a.366.366,0,0,1,.046,0c.8,0,1.594-.008,2.389,0a1.556,1.556,0,0,1,1.434.888,1.8,1.8,0,0,1,.181,1.117,1.716,1.716,0,0,1-.526,1.04,1.46,1.46,0,0,1-.5.316c-.014,0-.025.013-.044.021.227.606.454,1.209.686,1.827h-.093c-.213,0-.426,0-.637,0a.109.109,0,0,1-.121-.086c-.2-.532-.4-1.062-.6-1.593-.014-.039-.027-.063-.074-.063-.43,0-.858,0-1.288,0-.011,0-.023,0-.042,0Zm0-2.606.043,0c.53,0,1.061,0,1.592,0a.764.764,0,0,0,.178-.022.885.885,0,0,0,.516-1.294.766.766,0,0,0-.72-.416l-1.054,0h-.555v1.732"
                transform="translate(-943.33 -599.801)"
                fill={color}
              />
            </g>
          </g>
        </g>
      </svg>
    </motion.div>
  );
}
